// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getLedgersParameter = (state: ApplicationState) => {
    return state.store.pages.billingStatus.getLedgersParameter;
};

export const getBillingStatusFiltersOpen = (state: ApplicationState) => {
    return state.store.pages.billingStatus.filtersOpen;
};
